import React from "react";

import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { useAppContext } from "@state/hooks/shared";
import { getCurrentCulture } from "@utils";
import { observer } from "mobx-react";

export default observer(function WithdrawalTabSwitcher() {
	const { t } = useTranslation("payment");
	const { culture } = useAppContext();

	return (
		<div className="card--primary__tabs u-padd--x--reset">
			<nav className="tabs--primary">
				<NavLink
					className="tabs--primary__item"
					activeClassName="is-active"
					replace={true}
					to={`/${culture}/withdrawal`}
					isActive={(match, location) => {
						return (
							location.pathname ==
							`/${getCurrentCulture()}/withdrawal`
						);
					}}
				>
					{t<string>("WITHDRAWAL.NEW_WITHDRAWAL")}
				</NavLink>
				<NavLink
					to={`/${culture}/withdrawal/history`}
					className="tabs--primary__item"
					replace={true}
					activeClassName="is-active"
					isActive={(match, location) => {
						return (
							location.pathname ==
							`/${getCurrentCulture()}/withdrawal/history`
						);
					}}
				>
					{t<string>("WITHDRAWAL.MY_WITHDRAWALS")}
				</NavLink>
			</nav>
		</div>
	);
});
